var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 12",
    style: {
      enableBackground: "new 0 0 22 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 9h-2L3.8 6.3 2.2 9H.3l2.5-4L.4 1.1h2l1.4 2.6 1.5-2.6h1.9L4.7 4.9 7.3 9zM8.5 1.1h1.7v6.5H14V9H8.5V1.1zM18.2 7.9c.4 0 .7 0 1-.1.5-.2.7-.5.7-.9 0-.3-.1-.5-.3-.6-.2-.1-.6-.3-1.1-.4l-.8-.2c-.8-.2-1.4-.4-1.7-.6-.5-.4-.8-.9-.8-1.7 0-.7.3-1.3.8-1.8s1.3-.7 2.3-.7c.8 0 1.5.2 2.1.7.6.4.9 1.1.9 1.9h-1.6c0-.5-.2-.8-.6-1-.3-.1-.6-.2-1-.2s-.8.1-1 .3c-.3.2-.4.4-.4.7 0 .3.1.5.4.6.2.1.5.2 1 .3l1.4.3c.6.1 1 .3 1.4.6.5.4.7.9.7 1.6 0 .7-.3 1.3-.8 1.8-.6.5-1.3.7-2.3.7-1 0-1.8-.2-2.4-.7S15 7.4 15 6.6h1.6c0 .4.1.6.3.8.2.3.7.5 1.3.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.02cb11c4c6f6b762a1dcd7d805b6e9f6.svg";
export { ForwardRef as ReactComponent };